<template>
    <el-table :data="mapedData" stripe max-height="250" size="mini" :show-header="false">
        <el-table-column prop="d"></el-table-column>
    </el-table>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: ()=>[]
        }
    },
    computed: {
        mapedData() {
            return this.tableData.map(item=>{ return { d: item } } )
        }
    }
}
</script>

<style>

</style>
